import styled from 'styled-components';

/* The table's own box, since it no longer sits inside a nested card. */
export const Frame = styled.div`
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  overflow: hidden;
`;

/* Alignment and nothing else — see the note in the user list's copy. */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;
